module.exports = __webpack_public_path__ + "static/images/containers/ClanManagement/components/MembersControlBlock/images/allocate_treasury.9d2218bb.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanManagement/components/MembersControlBlock/images/allocate_treasury.png
// module id = 3055
// module chunks = 11